import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@iot-platform/core';
import { AbstractDeviceCommandService } from '@iot-platform/data-access/devices';
import { DeviceLastCommand, Environment } from '@iot-platform/models/common';
import { Device } from '@iot-platform/models/i4b';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeviceCommandService extends AbstractDeviceCommandService<Device> {
  private readonly environment: Environment = inject(ENVIRONMENT);
  private readonly httpClient: HttpClient = inject(HttpClient);

  getLastCommandStatus(device: Device): Observable<DeviceLastCommand | null> {
    return this.httpClient.get<DeviceLastCommand | null>(`${this.environment.api.url}${this.environment.api.endpoints.devices}/${device.id}/last-command`);
  }
}
